export const SupportIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3c3d10"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="5" width="18" height="14" rx="2"></rect>
      <path d="M3.5 6.5 12 13l8.5-6.5"></path>
    </svg>
  );
};
